<div class="popup-modal">
  <div class="popup-modal-body">
    <ng-content></ng-content>
  </div>
</div>
<div class="popup-modal-background"></div>
